import Image from "next/image";

import { Link } from "@/components/link/link.component";

import { resolveLinkHref } from "@/utils/url.util";

import { brown } from "@/app/font";
import type { GetHomePageQueryResult } from "@/sanity.types";

export const AdtAwards = ({ block }: { block: AwardsBlock }) => {
  const renderAwards = () => {
    return (block.awards ?? []).map((award) => (
      <div
        key={award._key}
        className="flex w-[40%] max-w-[160px] flex-col items-center justify-end text-center">
        {award.caption ? (
          <p className="text-adt-blue mb-1 text-sm leading-none font-medium tracking-wide">
            {award.caption}
          </p>
        ) : null}
        <div className="flex h-40 w-full items-end justify-center sm:h-52 lg:h-[240px]">
          <Image
            src={award.url ?? ""}
            alt=""
            width={240}
            height={217}
            sizes="(max-width: 639px) 30vw, (max-width: 1023px) 22vw, 240px"
            className="h-full w-auto max-w-full object-contain"
          />
        </div>
      </div>
    ));
  };

  return (
    <section
      aria-labelledby="adt-awards-heading"
      className="overflow-hidden bg-center bg-no-repeat py-12 sm:py-10 xl:bg-cover xl:px-[11.15vw] xl:py-16"
      style={
        block.backgroundImage?.url
          ? { backgroundImage: `url(${block.backgroundImage.url})` }
          : undefined
      }>
      <div className="grid items-center gap-10 px-6 sm:px-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.5fr)] lg:gap-16 xl:gap-24 xl:px-0">
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
          <h2
            id="adt-awards-heading"
            aria-label={block.title ?? undefined}
            className={`${brown.className} headline-3 text-greyscale-headline max-w-[600px]`}>
            {block.title}
          </h2>
          {block.cta?.link && block.cta?.label ? (
            <Link
              href={resolveLinkHref(block.cta.link)}
              primary
              className="mt-8 min-h-16 w-full max-w-[600px] bg-[#2d68ad]! px-9 py-3 text-white! hover:bg-[#2d68ad]! lg:w-fit">
              {block.cta.label}
            </Link>
          ) : null}
        </div>

        <div className="flex flex-nowrap items-end justify-center gap-3 overflow-x-auto sm:justify-between sm:gap-8">
          {renderAwards()}
        </div>
      </div>
    </section>
  );
};

type AwardsBlock = Extract<
  NonNullable<NonNullable<GetHomePageQueryResult>["pageBuilder"]>[number],
  { _type: "adtAwards" }
>;
